"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _commonPropTypes = _interopRequireDefault(require("./common-prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SelectControl =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectControl, _Component);

  function SelectControl() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectControl)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "initElementRef", function (element) {
      _this.element = element;
    });

    _defineProperty(_assertThisInitialized(_this), "renderOption", function (item, key) {
      var optionProps = Object.assign({}, item);
      delete optionProps.label;
      delete optionProps.group;
      return _react.default.createElement("option", _extends({
        key: key
      }, optionProps), item.label);
    });

    return _this;
  }

  _createClass(SelectControl, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var options = this.props.options;
      var groups = options.filter(function (item) {
        return item.group;
      }).map(function (item) {
        return item.group;
      }); // Get the unique items in group.

      groups = _toConsumableArray(new Set(groups));
      var optionNodes = [];

      if (groups.length === 0) {
        // eslint-disable-next-line react/no-array-index-key
        optionNodes = options.map(function (item, index) {
          return _this2.renderOption(item, index);
        });
      } else {
        // For items without groups.
        var itemsWithoutGroup = options.filter(function (item) {
          return !item.group;
        });
        itemsWithoutGroup.forEach(function (item, index) {
          // eslint-disable-next-line react/no-array-index-key
          optionNodes.push(_this2.renderOption(item, "no-group-".concat(index)));
        });
        groups.forEach(function (group, groupIndex) {
          var groupItems = options.filter(function (item) {
            return item.group === group;
          });
          var groupOptionNodes = groupItems.map(function (item, index) {
            return _this2.renderOption(item, "".concat(groupIndex, "-").concat(index));
          });
          /* eslint-disable react/no-array-index-key */

          optionNodes.push(_react.default.createElement("optgroup", {
            label: group,
            key: groupIndex
          }, groupOptionNodes));
          /* eslint-enable */
        });
      }

      var selectProps = Object.assign({}, this.props);
      delete selectProps.options;
      return _react.default.createElement("select", _extends({
        className: "form-control"
      }, selectProps, {
        ref: this.initElementRef
      }), optionNodes);
    }
  }]);

  return SelectControl;
}(_react.Component);

SelectControl.propTypes = _objectSpread({}, _commonPropTypes.default, {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    group: _propTypes.default.string
  })).isRequired,
  multiple: _propTypes.default.bool
});
SelectControl.defaultProps = {
  multiple: false
};
var _default = SelectControl;
exports.default = _default;